import { render, staticRenderFns } from "./Communication.vue?vue&type=template&id=46698fd4&"
import script from "./Communication.vue?vue&type=script&lang=js&"
export * from "./Communication.vue?vue&type=script&lang=js&"
import style0 from "./Communication.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports